export default "__VITE_ASSET__C5iMPL3f__"